export function getSelectionText() {
    let text = '';

    if (window.getSelection) {
        text = window.getSelection().toString();
    } else if (typeof document.selection !== 'undefined' && document.selection.type !== 'Control') {
        text = document.selection.createRange().text;
    }

    return text;
}
